<fcom-cta-button
  data-testid="one-upgrade-continue-footer-cta-button"
  [visible]="true | finToObservable | finDelay | async"
  [title]="continueButtonI18n$ | async | finLocalization"
  [disabled]="
    (stage === Stage.PASSENGERS
      ? (passengerStageCompleted$ | async) === false
      : (this.flightsBasket$ | async).length === 0) || loading
  "
  [loading]="loading"
  [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT }"
  [position]="ButtonPosition.GRID_FULL"
  [finElemTracker]="'continue-button_continue-to-continue-button-upgrade'"
  [finElemState]="'valid'"
  [finElemContext]="'one-upgrade'"
  [finElemType]="ElementTypes.BUTTON"
  (buttonClicked)="onContinue($event)"
>
  <div class="flex flex--center">
    <span class="gray-50-text ps-xsmall-r">{{ 'total' | finLocalization }}: </span>
    <div class="flex flex--column text-wrapper">
      <div class="font-body-1 bold-type align-left truncate overflow-hidden" data-testid="upgrade-footer-cta-price">
        <div
          class="truncate overflow-hidden"
          *ngFor="let payment of selectedPayments$ | async; let last = last"
          [title]="payment"
        >
          {{ payment }}<ng-container *ngIf="!last">, <br /></ng-container>
        </div>

        <ng-container *ngIf="(selectedPayments$ | async).length === 0">&ndash;</ng-container>
      </div>
    </div>
  </div>
</fcom-cta-button>
